import React from 'react';
import { HeadlineLarge } from "../../atoms/fonts/Headline";
import { BodyRegular } from "../../atoms/fonts/Body";
import { LinkButton } from "../../atoms/buttons/LinkButton";
import styled from "styled-components";
import { PrimaryButton } from "../../atoms/buttons/PrimaryButton";
import { Trans, useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';
import { isCompanyAlreadyRegisteredError, RegisterErrorMessage } from './RegisterErrorMessage';

export enum MsalErrorCodes {
  accessDenied = 'access_denied',
  consentRequired = 'consent_required'
}

export function AzureErrorHandlingMessages(props: Props) {
  const {t} = useTranslation();
  return (
    <Wrapper>
      <HeadlineLarge style={{marginBottom: 16}}>{t(props.title)}</HeadlineLarge>
      {<ErrorMessage {...props} />}
      <PrimaryButton click={props.onRetryClicked} text="button.retry" fullWidth={true} size={ButtonSize.Large} style={{marginBottom: 24}} />
      {props.goBackLink && <LinkButton type="outline" text="button.go-back" link={props.goBackLink} fullWidth={true} size={ButtonSize.Large} />}
    </Wrapper>
  )
}

function ErrorMessage(props: Props) {
  if (isCompanyAlreadyRegisteredError(typeof props.errorCode === 'string' ? props.errorCode : null)) {
    return <RegisterErrorMessage errorMessage={props.errorCode} />
  }
  if (props.errorCode === MsalErrorCodes.consentRequired) {
    return <>
      <BodyRegular><Trans i18nKey="errors.azure.consent-message.message-1" /></BodyRegular>
      <BodyRegular style={{marginBottom: 16}}><Trans i18nKey="errors.azure.consent-message.message-2" /></BodyRegular>
    </>
  } else if (props.errorCode === MsalErrorCodes.accessDenied) {
    return <>
      <BodyRegular><Trans i18nKey="errors.azure.access-denied.message-1" /></BodyRegular>
      <BodyRegular style={{marginBottom: 16}}><Trans i18nKey="errors.azure.access-denied.message-1" /></BodyRegular>
    </>
  } else if (props.errorCode !== MsalErrorCodes.accessDenied && props.errorCode !== MsalErrorCodes.consentRequired) {
    return <>
      <BodyRegular><Trans i18nKey="errors.azure.not-access-den-and-not-consent.message-1" /></BodyRegular>
      <BodyRegular style={{marginBottom: 16}}><Trans i18nKey="errors.azure.not-access-den-and-not-consent.message-1" /></BodyRegular>
    </>
  } else {
    return null;
  }
}

interface Props {
  errorCode: any;
  title: string;
  onRetryClicked: any;
  goBackLink?: string;
}

const Wrapper = styled.div`
`
